/* EZ Rides — Contact page (sections/ez-contact.liquid).
   Two small jobs, no dependencies:

   1. Store picker. Every store's details card is already in the HTML, so
      switching stores only toggles [hidden] and swaps the single map
      iframe's src and title. Nothing is fetched and the page never jumps.
      Without JS the first store's map and card are already visible and each
      row still has a working "Directions" link.

   2. Contact form validation. The form validates natively when JS is off;
      when JS is on we take over (novalidate) so the messages are ours and
      land in an error slot that is always in the layout, so showing one
      never shifts the page. */
(function () {
  'use strict';

  /* ---------------- Store picker ---------------- */
  function initPicker(root) {
    var frame = root.querySelector('[data-ez-map]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ez-store]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ez-card]'));
    if (!buttons.length) return;

    function select(btn, focus) {
      var handle = btn.getAttribute('data-ez-store');

      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        c.hidden = c.getAttribute('data-ez-card') !== handle;
      });

      if (frame) {
        var src = btn.getAttribute('data-ez-src');
        var label = btn.getAttribute('data-ez-label') || '';
        if (src && frame.getAttribute('src') !== src) frame.setAttribute('src', src);
        if (label) frame.setAttribute('title', 'Map of ' + label);
      }

      if (focus) btn.focus();
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        select(btn, false);
      });

      btn.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            next = buttons[(i + 1) % buttons.length];
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            next = buttons[(i - 1 + buttons.length) % buttons.length];
            break;
          case 'Home':
            next = buttons[0];
            break;
          case 'End':
            next = buttons[buttons.length - 1];
            break;
          default:
            return;
        }
        event.preventDefault();
        select(next, true);
      });
    });
  }

  /* ---------------- Form validation ---------------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function fieldError(field) {
    var value = (field.value || '').trim();
    var required = field.hasAttribute('required');

    if (required && !value) return field.getAttribute('data-ez-msg-empty') || 'This field is required.';
    if (value && field.type === 'email' && !EMAIL.test(value)) {
      return field.getAttribute('data-ez-msg-format') || 'Enter an email address we can reply to.';
    }
    return '';
  }

  function showError(field, message) {
    var slot = field.form.querySelector('[data-ez-err-for="' + field.id + '"]');
    // Write into the live span, never the slot itself: the slot also holds the
    // hidden copies of each message that reserve the slot's height.
    if (slot) (slot.querySelector('[data-ez-err-live]') || slot).textContent = message;
    if (message) {
      field.setAttribute('aria-invalid', 'true');
    } else {
      field.removeAttribute('aria-invalid');
    }
  }

  function initForm(form) {
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-ez-validate]'));
    if (!fields.length) return;

    // Only now that we can show our own messages do we switch the native ones off.
    form.setAttribute('novalidate', 'novalidate');

    fields.forEach(function (field) {
      field.addEventListener('blur', function () {
        showError(field, fieldError(field));
      });
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') showError(field, fieldError(field));
      });
      field.addEventListener('change', function () {
        if (field.getAttribute('aria-invalid') === 'true') showError(field, fieldError(field));
      });
    });

    form.addEventListener('submit', function (event) {
      var first = null;

      fields.forEach(function (field) {
        var message = fieldError(field);
        showError(field, message);
        if (message && !first) first = field;
      });

      if (first) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-ez-picker]').forEach(initPicker);
    document.querySelectorAll('[data-ez-contact-form]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      if (form) initForm(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
